import * as yup from 'yup';
import { validateSsn } from '../../helpers/formHelpers/formHelpers';
import ISendReceipt from '../../interfaces/sendReceipt/sendReceipt';

export const sendReceiptInitialValues: ISendReceipt = {
	trackingNumbers: [],
	foreignSsn: false,
	identificationNumber: '',
	name: '',
	phone: '',
	email: '',
	files: [],
	hasReceipt: 'Yes',
	deliveryService: '0',
	additionalInformation: '',
	instructionsToStaff: '',
	isCompany: false,
};
const noStandaloneNumbers = /^(?!.*\b\d+\b)(?!\d+$).*$|^(?=.*\d)(?=.*[a-zA-Z]).*$/;

export const sendReceiptSchema = yup.object().shape({
	foreignSsn: yup.boolean(),
	identificationNumber: yup.string().when('foreignSsn', {
		is: false,
		then: yup.string().required('required').min(10, 'ssn-min').test('is-valid-ssn', 'ssn-valid', validateSsn),
	}),
	name: yup.string().required('required').matches(noStandaloneNumbers, 'name-invalid'),
	phone: yup
		.string()
		// phone requoire for individuals
		.when('isCompany', {
			is: false,
			then: yup
				.string()
				.required('required')
				.min(7, 'phone-min')
				.max(7, 'phone-max')
				.matches(/^[6-8][0-9]*$/, 'phone-invalid'),
		})
		.when('isCompany', {
			// phone optional for companies
			is: true,
			then: yup
				.string()
				.min(7, 'phone-min')
				.max(7, 'phone-max')
				.matches(/^[6-8][0-9]*$/, 'phone-invalid'),
		}),
	email: yup.string().email('email-invalid').required('required'),
	instructionsToStaff: yup.string().when('hasReceipt', {
		is: 'No',
		then: yup.string().required('required'),
	}),
	hasReceipt: yup.string().required('required'),
	deliveryService: yup.string().required('required'),
	files: yup
		.array()
		.of(yup.object().nullable())
		.min(1, 'file-min')
		.when('hasReceipt', {
			is: 'No',
			then: yup.array().of(yup.object().nullable()).min(0),
		}),
	additionalInformation: yup
		.string()
		.max(255, 'content-max')
		.when('hasReceipt', {
			is: 'Yes',
			then: yup.string().required('required').max(255, 'content-max'),
		})
		.when('instructionsToStaff', {
			is: 'other',
			then: yup.string().required('required').max(255, 'content-max'),
		})
		.when('instructionsToStaff', {
			is: 'gift',
			then: yup.string().required('required').max(255, 'content-max'),
		}),
	trackingNumbers: yup.array().of(yup.string()).min(1, 'trackingnumber-min'),
});
